import React from "react";
import {
  formatReferralDate,
  referralHeat,
  referralRowSubline,
  referralStatusMeta,
} from "../referralHelpers";

export default function ReferralsFloorRow({ referral, rank, selected, onSelect, heatPct }) {
  const status = referralStatusMeta(referral.status);
  const isReady = referral.rewardReady;
  const isRewarded = referral.status === "rewarded";
  const statusTone =
    status.tone === "live" ? "live" : status.tone === "warn" ? "warn" : "muted";

  const rowClass = [
    "amf-row",
    "arf-row",
    selected ? "amf-row-selected" : "",
    isReady ? "amf-row-ready amf-row-action" : "",
    isRewarded ? "amf-row-rewarded" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const progressPct = Math.round(Number(referral.progressPercent) || 0);

  return (
    <button
      type="button"
      className={rowClass}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <span
        className="amf-row-heat"
        style={{ "--heat": `${heatPct ?? referralHeat(referral)}%` }}
        title={isReady ? "Ready to claim" : isRewarded ? "Claimed" : "Unlock progress"}
        aria-hidden
      />
      <span className="amf-row-rank">{String(rank).padStart(2, "0")}</span>
      <span className="amf-row-body arf-row-body">
        <span className="amf-row-top arf-row-top">
          <span className="amf-row-name" title={referral.referrer?.name}>
            {referral.referrer?.name || "Referrer"}
            <span className="arf-desk-arrow"> → </span>
            {referral.referee?.name || "Referee"}
          </span>
          <span className={`amf-row-tag amf-row-tag-${statusTone}`}>
            {isReady && referral.status === "pending" ? "Ready" : status.label}
          </span>
        </span>
        <span className="amf-row-sub arf-row-sub">
          <span>{referralRowSubline(referral)}</span>
          {referral.status === "pending" ? (
            <span className="arf-row-progress">
              <span className="arf-row-progress-bar">
                <span
                  className={`arf-row-progress-fill ${isReady ? "arf-row-progress-fill-ready" : ""}`}
                  style={{ width: `${progressPct}%` }}
                />
              </span>
              <span className="arf-row-progress-label">{progressPct}%</span>
            </span>
          ) : (
            <span>{formatReferralDate(referral.rewardedAt || referral.createdAt)}</span>
          )}
        </span>
      </span>
    </button>
  );
}

export { referralHeat };
